import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=29f5d050&scoped=true"
import script from "./TestCard.vue?vue&type=script&lang=js"
export * from "./TestCard.vue?vue&type=script&lang=js"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=29f5d050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f5d050",
  null
  
)

export default component.exports